import React, { useState } from "react";
import axios from "axios";

const useCategory = ({
    onFinish = ({ axiosMode, status, values }) => {},
    onBefore = ({ axiosMode, status }) => {},
}) => {
    const [data, setData] = useState([]);
    let mainApi = `/media_classification_storage/api/classify/media/category`;
    const getCategoryData = (params) => {
        onBefore({
            axiosMode: "get",
        });
        return axios
            .get(mainApi, {
                params: params,
            })
            .then((response) => {
                let data = response.data;
                setData(data?.data || []);
                if (data) {
                    onFinish({
                        axiosMode: "get",
                        status: "success",
                    });
                } else {
                    onFinish({
                        axiosMode: "get",
                        status: "error",
                    });
                }

                return {
                    ...data,
                };
            });
    };
    const postCategoryData = (data) => {
        onBefore({
            axiosMode: "post",
        });
        axios
            .post(mainApi, data)
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "fail") {
                    onFinish({
                        axiosMode: "post",
                        status: "error",
                    });
                } else {
                    onFinish({
                        axiosMode: "post",
                        status: "success",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "post",
                    status: "error",
                });
            });
    };
    const patchCategoryData = (data) => {
        onBefore({
            axiosMode: "patch",
        });
        axios
            .patch(
                mainApi,

                data
            )
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "fail") {
                    onFinish({
                        axiosMode: "patch",
                        status: "error",
                    });
                } else {
                    onFinish({
                        axiosMode: "patch",
                        status: "success",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "patch",
                    status: "error",
                });
            });
    };
    const deleteCategoryData = (data) => {
        onBefore({
            axiosMode: "delete",
        });
        axios
            .delete(mainApi, {
                data,
            })
            .then((response) => {
                let responseData = response.data;
                let status = responseData?.status;
                if (status === "fail") {
                    onFinish({
                        axiosMode: "delete",
                        status: "error",
                    });
                } else {
                    onFinish({
                        axiosMode: "delete",
                        status: "success",
                    });
                }
            })
            .catch(() => {
                onFinish({
                    axiosMode: "delete",
                    status: "error",
                });
            });
    };
    return {
        CategoryData: data,
        getCategoryData,
        postCategoryData,
        patchCategoryData,
        deleteCategoryData,
    };
};
export { useCategory };
